export const BUSINESS_REPORT_HEADER = [
  { label: '日付', sortable: false, sortKey: '', width: '200px' },
  { label: 'PJ NO', sortable: false, sortKey: '', width: '220px' },
  { label: 'プロジェクト名', sortable: false, sortKey: '', width: '200px' },
  { label: '工数A', sortable: false, sortKey: '', width: '80px' },
  { label: '工数B', sortable: false, sortKey: '', width: '80px' },
  { label: '工数C', sortable: false, sortKey: '', width: '80px' },
  { label: '工数D', sortable: false, sortKey: '', width: '80px' },
  { label: '工数E', sortable: false, sortKey: '', width: '80px' },
  { label: '始業時間', sortable: false, sortKey: '', width: '180px' },
  { label: '終業時間', sortable: false, sortKey: '', width: '180px' },
  { label: '工数', sortable: false, sortKey: '', width: '80px' },
  { label: '操作', sortable: false, sortKey: '', width: '150px' },
];
